import { ApiError } from "@client/lib/api";

type ErrorBoxProps = {
  readonly error: unknown;
};

export function ErrorBox({ error }: ErrorBoxProps) {
  const message =
    error instanceof ApiError ? error.message : error instanceof Error ? error.message : "Nieznany błąd.";
  const requestId = error instanceof ApiError ? error.requestId : undefined;
  return (
    <div className="flex flex-col gap-1 rounded-md border border-danger/40 bg-surface px-4 py-3 text-sm">
      <div className="font-medium text-danger">{message}</div>
      {requestId != null && <div className="mono text-xs text-fg-4">ID żądania: {requestId}</div>}
    </div>
  );
}
